// extracted by mini-css-extract-plugin
export default {"imgDescription":"ArtDescription_imgDescription__rcaJN"};